import React from "react";

interface LoadingEllipsesProps {
  label?: string;
}
const LoadingEllipses = ({ label = "Loading..." }: LoadingEllipsesProps): React.ReactNode => {
  return (
    <div title={label} role="img" className="loading-ellipses">
      <div>&nbsp;</div>
      <div>&nbsp;</div>
      <div>&nbsp;</div>
    </div>
  );
};

export default LoadingEllipses;
